import { EventItem } from 'queries/events/types';
import { EVENT_PAGE } from 'config/paths';
import LaunchOutlinedIcon from '@mui/icons-material/LaunchOutlined';

export const SimilarEventLink: React.FC<EventItem> = (item) => {
  if (!item.children || item.children.length === 0) {
    return (
      <LaunchOutlinedIcon
        onClick={() => window.open(EVENT_PAGE(item.id), '_blank')}
        data-testid="expand-icon"
        className="table-similar-event-link"
      />
    );
  }
  return null;
};
